export interface ESProperty {
	propertyName: string
	weight: number
	searchEnabled: boolean
	returnInResults: boolean
}

export interface NestedESProperty extends ESProperty {
	nestedFields: ESProperty[]
}

export interface ElasticsearchConfig {
	indexName: string
	properties: ESProperty[]
	nestedProperties?: NestedESProperty[]
	facetFields?: string[]
}

export enum CodeSystem {
	Adm = 'adm',
	Icd10 = 'icd10',
	Icpc2 = 'icpc2',
	Icpc2b = 'icpc2b',
	Nkpk = 'nkpk',
	Phbu = 'phbu',
	Norpat = 'norpat',
	Apat = 'apat',
	Nlk = 'nlk',
	provemateriale = 'provemateriale',
	anatomisk = 'anatomisk',
	snomedct = 'snomedct',
	snomed = 'snomed',
	tekstligeresultatverdier = 'tekstligeresultatverdier',
	undersokelsesmetode = 'undersokelsesmetode',
}

const esConfig: Partial<Record<CodeSystem, ElasticsearchConfig>> = {
	[CodeSystem.Adm]: {
		indexName: 'search-ehelse-kodeverk-dev-kis',
		properties: [
			{
				propertyName: 'code_system_oid',
				weight: 1,
				searchEnabled: true,
				returnInResults: true,
			},
			{
				propertyName: 'name_norwegian',
				weight: 3,
				searchEnabled: true,
				returnInResults: true,
			},
			{
				propertyName: 'description',
				weight: 2,
				searchEnabled: true,
				returnInResults: true,
			},
			{
				propertyName: 'owner_name',
				weight: 1,
				searchEnabled: true,
				returnInResults: true,
			},
			{
				propertyName: 'collection_name',
				weight: 1,
				searchEnabled: true,
				returnInResults: true,
			},
			{
				propertyName: 'category_name',
				weight: 1,
				searchEnabled: true,
				returnInResults: true,
			},
			{
				propertyName: 'valid_from',
				weight: 1,
				searchEnabled: false,
				returnInResults: true,
			},
			{
				propertyName: 'valid_to',
				weight: 1,
				searchEnabled: false,
				returnInResults: true,
			},
			{
				propertyName: 'status_text',
				weight: 1,
				searchEnabled: false,
				returnInResults: true,
			},
			{
				propertyName: 'active',
				weight: 1,
				searchEnabled: false,
				returnInResults: false,
			},
			{
				propertyName: 'status_changed_date',
				weight: 1,
				searchEnabled: false,
				returnInResults: false,
			},
			{
				propertyName: 'id',
				weight: 1,
				searchEnabled: false,
				returnInResults: false,
			},
			{
				propertyName: 'owner_id',
				weight: 1,
				searchEnabled: false,
				returnInResults: false,
			},
			{
				propertyName: 'collection_id',
				weight: 1,
				searchEnabled: false,
				returnInResults: false,
			},
			{
				propertyName: 'category_id',
				weight: 1,
				searchEnabled: false,
				returnInResults: false,
			},
		],
		nestedProperties: [
			{
				propertyName: 'codes',
				weight: 1,
				searchEnabled: true,
				returnInResults: true,
				nestedFields: [
					{
						propertyName: 'name_norwegian',
						weight: 3,
						searchEnabled: true,
						returnInResults: true,
					},
					{
						propertyName: 'code',
						weight: 3,
						searchEnabled: true,
						returnInResults: true,
					},
					{
						propertyName: 'description',
						weight: 2,
						searchEnabled: true,
						returnInResults: true,
					},
					{
						propertyName: 'active',
						weight: 1,
						searchEnabled: true,
						returnInResults: true,
					},
					{
						propertyName: 'valid_from',
						weight: 1,
						searchEnabled: false,
						returnInResults: false,
					},
					{
						propertyName: 'valid_to',
						weight: 1,
						searchEnabled: false,
						returnInResults: false,
					},
					{
						propertyName: 'active',
						weight: 1,
						searchEnabled: false,
						returnInResults: false,
					},
				],
			},
		],
		facetFields: ['status_text', 'owner_name'],
	},
}

export default esConfig
